import { WarmUpPickerParams } from '@wix/bex-core';
import { Essentials } from '@wix/fe-essentials/core';
import { buildCairoEssentials } from './buildCairoEssentials';
import { warmUpPickerStandalone as warmUpPickerStandaloneBase } from '../state/warmUpPickerStandalone';

export function warmUpPickerStandalone(
  essentials: Essentials,
  params: WarmUpPickerParams,
) {
  warmUpPickerStandaloneBase(buildCairoEssentials(essentials), params);
}
